import React, { Component, useState, useEffect } from "react";
//import React, { PureComponent } from 'react'
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import moment from "moment";
import FlightInfo from "./flightInfo";
import BagMtow from "./bagMtow";
import * as flightInfoTypes from "./flightInfoTypes";
import PassengerSummary from "./passengerSummary";
import WarningMessage from "./warningMessage";
import TZeroClock from "./tzeroClock";
import * as warningType from "../flightDetail/warningTypes";
import MapsTable from "./mapsTable";
import * as config from "../../data/config";
//import './custom.css'
//import styles from './FlightCard.module.scss'
import "./flightDetail.global.scss";

//class FlightCard extends PureComponent {
const FlightCard = (props) => {
  let flightDetail = props.flightDetail;
  let turnAroundTimeFinal = props.turnAroundTimeFinal;
  let depEdctDiffTime = props.depEdctDiffTime;
  var moment = require("moment");

  const [tZero, setTZero] = useState(0);
  const [tZerolabel, settZerolabel] = useState('');
  useEffect(() => {
    // Parse the turn around time, turn time offset, and departure EDCT difference time as integers
    const targetTurnTime = parseInt(turnAroundTimeFinal, 10);
    const turnTimeOffset = parseInt(config.environment.trunTimeOffset, 10);
    const taxiTime = parseInt(depEdctDiffTime, 10);

    // Check if the flight is a terminator flight
    if (flightDetail.TerminatorFlight > 0) {
      // If it is, calculate the TZero time by adding 15 minutes to the inbound on-time
      let date = moment(flightDetail.InTimeOutbound).add(15, "minutes");
      setTZero(date);
      settZerolabel('Terminator flight');
    } else {
      // If the flight is not a terminator flight, check if there's an outbound EDCT
      if (flightDetail.EDCT_Outbound) {
        // If there is, calculate the TZero time by subtracting the taxi time from the outbound EDCT ...........AC4
        let t0DateVale = moment(flightDetail.EDCT_Outbound)
          .clone()
          .subtract(taxiTime, "minutes");
        setTZero(t0DateVale);
        settZerolabel('AC4: EDCT - taxiTime');
      } else if (
        // If there's no outbound EDCT, check if the outbound departure time and inbound on-time exist and if the outbound departure time is later than the final time .......AC3;
        flightDetail.ETD_Outbound &&
        flightDetail.InTime &&
        moment(flightDetail.ETD_Outbound).isAfter(
          calculateOntimeWithTargetTurnTime(
            flightDetail.InTime,
            targetTurnTime,
            turnTimeOffset
          )
        )
      ) {
        //  set the TZero time to the outbound ETD
        setTZero(flightDetail.ETD_Outbound);
        settZerolabel('AC3: ATA + target turn time + additional 30 mins');
      } else if (
        // If not, check if the standard outbound time and inbound on-time exist and if the standard time with inbound on-time is less than the target turn time .......AC2;
        flightDetail.STD_Outbound &&
        flightDetail.InTime &&
        moment
          .duration(moment(flightDetail.STD_Outbound).diff(moment(flightDetail.InTime)))
          .asMinutes() < targetTurnTime
      ) {
        //  calculate the TZero time by adding the target turn time to the inbound on-time
          let t0DateVale = moment(flightDetail.InTime)
          .clone()
          .add(targetTurnTime, "minutes");
        setTZero(t0DateVale);
        settZerolabel('AC2: flightDetail.InTime + targetTurnTime');
      } else {
        // If none of the above conditions are met, set the TZero time to the standard outbound time .... AC1;

        setTZero(flightDetail.STD_Outbound);
        settZerolabel('AC1: outbound STD_Outbound');
      }
    }
  }, [flightDetail]);

  const calculateOntimeWithTargetTurnTime = (
    onTimeInbound,
    targetTurnTime,
    turnTimeOffset
  ) => {
    let constantTime = targetTurnTime + turnTimeOffset;
    let adjustedTime = moment(onTimeInbound)
      .clone()
      .add(constantTime, "minutes");
    return adjustedTime;
  };


  // let flightNumInbound = flightDetail.FltNumInbound;
  //console.info("flightNumInbound", flightNumInbound);

  //let abc = flightDetail.PassengerDetails;
  //let passInboundFltNumber = abc.flightNumInbound;
  //console.info("abc", abc);

  let onShowModal = props.onShowModal;
  let serverOffSet = props.serverOffSet;

  let yellowWarning = props.yellowWarning;
  //console.info("znnbhdz", yellowWarning);

  //Set up direction based parameters
  let outboundDepartTime = moment(flightDetail.ETD_Outbound).format("HH:mm");
  let previousOutDepartTime = moment(flightDetail.STD_Outbound).format("HH:mm");

  let inboundArrivalTime = moment(flightDetail.ETA_Inbound).format("HH:mm");
  let inboundArrivalTimeInTime = moment(flightDetail.InTime).format("HH:mm");
  let outboundArrivalTime = moment(flightDetail.ETA_Outbound).format("HH:mm");

  let previousOutArrivalTime = moment(flightDetail.ETA_Outbound).format(
    "HH:mm"
  );
  let previousInArrivalTime = moment(flightDetail.STA_Inbound).format("HH:mm");

  let isTerminatorFlight = flightDetail.TerminatorFlight > 0;
  let MAX_TURNARDOUNT_TIME_MIN;
  //let previousInArrivalTime = moment(flightDetail.STA_Outbound).format('HH:mm')

  //Filter all SSRs for Bag and Passenger Summary Component
  let { allSSR, filteredSSR } = "null";

  if (flightDetail.PassengerDetails != null) {
    allSSR = flightDetail.PassengerDetails.filter(
      (
        pax //Filter passengers who have SSR
      ) => pax.SSRDetails != null
    );
  }
  //debugger

  // remove all Inbound SSRs for Non-confirmed pax
  if (allSSR != null && allSSR.length > 0) {
    if (!isTerminatorFlight) {
      filteredSSR = allSSR.filter(
        (pax) =>
          pax.Direction == "2" ||
          (pax.Direction == "1" &&
            (flightDetail.OffTime == null ||
              (flightDetail.OffTime != null &&
                (pax.LiftStatus == 1 || pax.LiftStatus == 2))))
      );
    } else {
      filteredSSR = allSSR.filter(
        (pax) =>
          pax.Direction == "2" &&
          (flightDetail.OffTimeOutbound == null ||
            (flightDetail.OffTimeOutbound != null &&
              (pax.LiftStatus == 1 || pax.LiftStatus == 2)))
      );
    }
  }

  //Get Passengers
  let { paxDetails, warningState } = "null";

  if (flightDetail != null) {
    if (flightDetail.PassengerDetails != null) {
      paxDetails = flightDetail.PassengerDetails.filter(
        (pax) => pax.Direction == "2"
      );
    }
  }

    //Get  Inbound Passengers
    let { paxDetailsInbound, warningState1,terminatorFlightPax} = 'null'

    if (flightDetail != null) {
        if (flightDetail.PassengerDetails != null) {
            if(isTerminatorFlight){
              terminatorFlightPax = flightDetail.PassengerDetails.filter(pax => pax.Direction == '2')
               }
            else{
                paxDetailsInbound = flightDetail.PassengerDetails.filter(pax => pax.Direction == '1')
            }

        }
    }
    
    //Logic to push warning state
    //console.info("boarding coflicts",flightDetail.Warnings);
    if (flightDetail.Warnings != null) {
        //console.info("boarding coflicts",flightDetail.Warnings);
        if ((flightDetail.Warnings.filter(warning => warning.Type == warningType.TAIL_SWAP).length > 0) ||                              //When there is a tail swap
            (flightDetail.Warnings.filter(warning => warning.Type == warningType.ETD_STD_DIFF).length > 0) ||                           //Or when outbound has a delay
            (flightDetail.Warnings.filter(warning => warning.Type == warningType.CURFEW).length > 0) ||                                 //Or curfew alert
            (flightDetail.Warnings.filter(warning => warning.Type == warningType.BOARDING_CONFLICT).length > 0) ||                       //Or boarding conflict
            (flightDetail.Warnings.filter(warning => warning.Type == warningType.EDCT).length > 0))                         //Or edct CANCELLATION
        {
            warningState = 'warning'
        }
    }

  let finalWarning = [];

  if (flightDetail.Warnings != null) {
    finalWarning = flightDetail.Warnings.filter(
      (warning) =>
        (warning.Type != warningType.DELAY || //Filter in any non-delay warnings
          (warning.Type == warningType.DELAY && warning.Direction == 2)) && //Filter in outbound delay warnings
        warning.Type != warningType.COMPONENT_WEIGHT //Filter component weight
    );
  }

  //Separate Flight information into their own object

  const inboundFlightInfo = {
    UncorrectedTailNum: flightDetail.UncorrectedTailNumInbound,
    PreviousTailNum: flightDetail.PreviousTailNumInbound,
    LegHashKey: flightDetail.LegHashKeyInbound,
    FltNum: flightDetail.FltNumInbound,
    DepAirport: flightDetail.DepAirportInbound,
    ArrAirport: flightDetail.DepAirportOutbound,
    EDCT: null,
    ETA: inboundArrivalTime,
    ATA:inboundArrivalTimeInTime,
    STA: previousInArrivalTime,
    ETA_UTC: flightDetail.PreviousETA_UTC_Inbound,
    STA_UTC: flightDetail.PreviousSTA_UTC_Inbound,
    LastPaxOffTime: flightDetail.LastPaxOffTimeInbound,
    flightOpsComments: flightDetail.FlightOpsCommentsInbound,
    flightDirection: flightInfoTypes.INBOUND,
    terminatorFlight: flightDetail.TerminatorFlight,
    IATAMarketingcodeInbound: flightDetail.IATAMarketingcodeInbound,
  };

  const outboundFlightInfo = {
    LegHashKey: flightDetail.LegHashKey,
    FltNum: flightDetail.FltNumOutbound,
    DepAirport: flightDetail.DepAirportOutbound,
    ArrAirport: flightDetail.ArrAirportOutbound,
    STD_UTC: flightDetail.STD_UTC_Oubound,
    STA_UTC: flightDetail.STA_UTC_Oubound,
    ETD_UTC: flightDetail.ETD_UTC_Oubound,
    ETA_UTC: flightDetail.ETA_UTC_Oubound,
    EDCT_UTC: flightDetail.EDCT_UTC_Oubound,
    STD:
      inboundFlightInfo.terminatorFlight == 1
        ? previousOutArrivalTime
        : previousOutDepartTime,
    STA: moment(flightDetail.STA_Outbound).format("HH:mm"),
    ETD:
      inboundFlightInfo.terminatorFlight == 1
        ? outboundArrivalTime
        : outboundDepartTime,
    ETA: moment(flightDetail.ETA_Outbound).format("HH:mm"),
    EDCT: flightDetail.EDCT_Outbound,
    UncorrectedTailNum: flightDetail.UncorrectedTailNum,
    PreviousTailNum: flightDetail.PreviousTailNumOutbound,
    LastPaxOffTime: flightDetail.LastPaxOffTimeOutbound,
    flightOpsComments: flightDetail.FlightOpsCommentsOutbound,
    flightDirection: flightInfoTypes.OUTBOUND,
    terminatorFlight: flightDetail.TerminatorFlight,
    IATAMarketingcodeOutbound: flightDetail.IATAMarketingcodeOutbound,
    ModelOutbound: flightDetail.ModelOutbound,
  };
  //Show warning icon logic
  // function showWarningIcon(warning) {
  //     if (warning) {
  //         return (<ErrorIcon />)
  //     }
  // }

  function showInboundFlight(flightKey) {
    //if inbound is null but terminator flight, then return outbound as inbound
    if (inboundFlightInfo.terminatorFlight == 1) {
      return (
        <Grid item xs={4}>
          <FlightInfo
            depEdctDiffTime={depEdctDiffTime}
            type={flightInfoTypes.INBOUND}
            flightDetail={outboundFlightInfo}
            onShowModal={onShowModal}
          />
        </Grid>
      );
    } else if (
      flightKey.LegHashKey == null &&
      flightKey.terminatorFlight == 0
    ) {
      return (
        <Grid item xs={4} alignItems="center" direction="row">
          <h5 className="fi_departing center terminator">Head Start</h5>
        </Grid>
      );
    } else if (flightKey.LegHashKey != null) {
      return (
        <Grid item xs={4}>
          <FlightInfo
            depEdctDiffTime={depEdctDiffTime}
            type={flightInfoTypes.INBOUND}
            flightDetail={inboundFlightInfo}
            onShowModal={onShowModal}
          />
        </Grid>
      );
    }
  }

  function showOutboundFlight(flightKey) {
    //console.info("hdhjhfg", flightKey);
    //console.info("hdhjhfg outboundFlightInfo", outboundFlightInfo);

    if (inboundFlightInfo.terminatorFlight == 0) {
      return (
        <Grid item xs={4}>
          <FlightInfo
            depEdctDiffTime={depEdctDiffTime}
            type={flightInfoTypes.OUTBOUND}
            flightDetail={outboundFlightInfo}
            onShowModal={onShowModal}
            t0={tZero}
            t0label={tZerolabel}
          />
        </Grid>
      );
    } else {
      return (
        <Grid item xs={4} alignItems="center" direction="row">
          <h5 className="fi_departing center terminator">Terminator</h5>
        </Grid>
      );
    }
  }

  //Sometimes a gate is not assigned, therefore showing gate "X"
  let gateNumber = "";

  if (flightDetail.TerminatorFlight > 0) {
    gateNumber = flightDetail.ArrGate == "" ? "X" : flightDetail.ArrGate;
  } else {
    gateNumber = flightDetail.DepGate == "" ? "X" : flightDetail.DepGate;
  }

  //Max Value definition
  function defineMaxValue() {
    if (flightDetail != null) {
      if (flightDetail.TerminatorFlight > 0) {
        MAX_TURNARDOUNT_TIME_MIN = turnAroundTimeFinal; //30 
        //console.info(
        //  "yonge 00 hello ",
        //  MAX_TURNARDOUNT_TIME_MIN + " " + flightDetail.FltNumOutbound
        //);
      } else {
        if (flightDetail.ETA_Inbound == null) {
          //console.info("first day of flight 5", flightDetail.FltNumOutbound);
          MAX_TURNARDOUNT_TIME_MIN = moment(
            moment().startOf("day").hour(5).minute(0)
          ).diff(flightDetail.ETD_Outbound, "minutes");
        } else if (flightDetail.InTime != null) {
          //once the IN time is available, the max value is outbound ETD minus IN time, use this value for new local max value, remove the 'estimate' label
          //console.info("if intime is not null", flightDetail.FltNumOutbound);
          MAX_TURNARDOUNT_TIME_MIN = moment(flightDetail.InTime).diff(
            tZero,
            "minutes"
          );
        } else if ( flightDetail.EDCT_Outbound != null && flightDetail.OffTime != null && flightDetail.InTime == null ) {
          //If EDCT exist but In time doesn't exist, use ETA Inbound.
          MAX_TURNARDOUNT_TIME_MIN = moment(flightDetail.ETA_Inbound).diff(
            moment(flightDetail.EDCT_Outbound).subtract(
              depEdctDiffTime,
              "minutes"
            ),
            "minutes"
          );
        } else {
          //If EDCT, IN time don't exist, outbound ETD minus inbound ETA, use this value locally as max value
          if (flightDetail.OffTime != null) {
            //When off time is not null, do the first calculation
            MAX_TURNARDOUNT_TIME_MIN = moment(flightDetail.ETA_Inbound).diff(
              flightDetail.ETD_Outbound,
              "minutes"
            );
          } else {
            //If off time is null, don't show anything
            MAX_TURNARDOUNT_TIME_MIN = "--";
          }
        }
      }
    }

    return MAX_TURNARDOUNT_TIME_MIN;
  }

  if (flightDetail != null) {
    return (
      <Paper>
        <div className={`gate ${warningState}`}>
          Gate &nbsp;<span className="gateNumber">{gateNumber}</span>
        </div>
        <div className="clear"></div>

        <Grid container spacing={1}>
          {showInboundFlight(inboundFlightInfo)}
          <Grid item xs={4}>
            <TZeroClock
              turnAroundTimeFinal={turnAroundTimeFinal}
              depEdctDiffTime={depEdctDiffTime}
              flightDetail={flightDetail}
              serverOffSet={serverOffSet}
              yellowWarning={yellowWarning}
              max_TURNARDOUNT_TIME_MIN={defineMaxValue()}
              finalDate={tZero}
            />
          </Grid>
          {showOutboundFlight(outboundFlightInfo)}
        </Grid>
        <WarningMessage
          flightDetail={flightDetail}
          warningState={warningState}
          warningList={finalWarning}
        />
        <hr className="separator" />
        {/* <BoardingAnnouncements boarding={true} boardingCompleted={false} wbSubmitted={true} doorClosed={false} /> */}
        <MapsTable flightDetail={flightDetail} finalDate={tZero} />
        <BagMtow
          depEdctDiffTime={depEdctDiffTime}
          allSSR={filteredSSR}
          onShowModal={onShowModal}
          flightDetail={flightDetail}
        />
        <hr className="separator mb0" />
        <div></div>
        <PassengerSummary
          allSSR={filteredSSR}
          data={paxDetails}
          onShowModal={onShowModal}
          flightDetail={flightDetail}
          dataInbound={paxDetailsInbound}
          terminatorPax={terminatorFlightPax}
        />
      </Paper>
    );
  }
  return <div></div>;
};

export default FlightCard;
